var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormModel',{attrs:{"add-action":_vm.addAction,"update-action":_vm.updateAction,"delete-action":_vm.deleteAction,"view-action":_vm.viewAction,"archive-action":_vm.archiveAction,"unarchive-action":_vm.unarchiveAction,"type":"FOOTER"}})}
var staticRenderFns = []

export { render, staticRenderFns }